import styled from 'styled-components';
import Colors from '../../constants/Colors';

const Surface_OLD = styled.div`
  padding: 12px;
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.GRAY[5]};
  border-radius: 16px;
  box-shadow: 0px 8px 6px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 992px) {
    margin: 0px 10px 0px 10px
  }
`;

const Surface = styled.div`
  padding: 2rem 4rem;
  background-color: ${Colors.WHITE};
  border: 4px solid ${Colors.SECONDARY};
  border-radius: 40px;
  box-shadow: 0px 5px 20px 5px rgba(0,0,0,0.1);

  @media screen and (min-width: 769px) {
    min-height: 385px;
    position: relative;
  }
  
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

export default Surface;